import { type IConfig } from '@cian/config/shared';

import {
  dealTypeFromJsonQuery,
  FDealType,
  isFlat,
  isSuburban,
  offerTypeFromJsonQuery,
} from 'shared/common/packages/JsonQuery';

import { getRegionId } from './region';
import { BX_HYBRID_SEARCH_EXPERIMENT } from '../constants/config';
import { isExperimentActive } from '../selectors/experiments';
import { IExperiment } from '../types/experiments';
import { TLocation } from '../types/location';

export type Params = {
  jsonQuery: TJsonQuery;
  config: IConfig;
  experiments: IExperiment[];
  location: TLocation;
};

export function isHybridSearchRedirectNeeded({ jsonQuery, config, experiments, location }: Params): boolean {
  const isFeatureEnabled = !!config.get<boolean>('BX.HybridSearch.Enabled');

  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const isCategoryValid =
    (dealType === FDealType.RentLongterm && isFlat(offerType)) ||
    (dealType === FDealType.Sale && isSuburban(offerType));

  const excludedRegions = config.get<number[]>('BX.HybridSearch.ExcludedRegions') || [];
  const regionId = getRegionId(location);
  const isValidRegion = !excludedRegions.includes(regionId);

  const isExperimentEnabled: boolean = isExperimentActive(experiments, BX_HYBRID_SEARCH_EXPERIMENT, 'B');

  return isFeatureEnabled && isCategoryValid && isValidRegion && isExperimentEnabled;
}
